import type { ButtonNode, MenuNode, MenuSchema, TextInputNode, TextNode } from '../MenuSchema.js';

export const ENTERTAINERS_MENU_ACTIONS = {
    refreshList: 'entertainers-refresh-list',
    sendTip: 'entertainers-send-tip',
} as const;

export const ENTERTAINERS_MENU_LABELS = {
    title: 'Entertainers',
    loading: 'Loading entertainers…',
    noEntertainers: 'No entertainers are currently available in this room.',
    yourBalancePrefix: 'Your Tokens:',
    tipAmount: 'Tip Amount',
    tipAmountPlaceholder: 'tokens to tip',
    refreshList: 'Refresh List',
    sendTip: 'Send Tip',
    notAuthenticated: 'Not authenticated.',
    selectEntertainer: 'Select an entertainer first.',
} as const;

export function createEntertainersMenuSchema(): MenuSchema {
    return {
        id: 'ENTERTAINERS',
        title: ENTERTAINERS_MENU_LABELS.title,
        nodes: [
            { type: 'text', text: ENTERTAINERS_MENU_LABELS.loading },
            { type: 'input', id: 'entertainers-tip-amount-input', placeholder: ENTERTAINERS_MENU_LABELS.tipAmountPlaceholder, get: () => '' },
            { type: 'button', id: ENTERTAINERS_MENU_ACTIONS.sendTip, label: ENTERTAINERS_MENU_LABELS.sendTip },
            { type: 'button', id: ENTERTAINERS_MENU_ACTIONS.refreshList, label: ENTERTAINERS_MENU_LABELS.refreshList },
        ],
    };
}

function findSchemaNodeById(schema: MenuSchema, id: string): MenuNode | undefined {
    return schema.nodes.find((n) => (n as { id?: string }).id === id);
}

export function readEntertainersSchemaButtonLabel(schema: MenuSchema, id: string, fallback: string): string {
    const node = findSchemaNodeById(schema, id) as ButtonNode | undefined;
    if (!node || node.type !== 'button') {
        return fallback;
    }
    return typeof node.label === 'function' ? node.label() : node.label;
}

export function readEntertainersSchemaInputPlaceholder(schema: MenuSchema, id: string, fallback: string): string {
    const node = findSchemaNodeById(schema, id) as TextInputNode | undefined;
    if (!node || node.type !== 'input') {
        return fallback;
    }
    return node.placeholder || fallback;
}

export function readEntertainersSchemaTextAt(schema: MenuSchema, index: number, fallback: string): string {
    const textNodes = schema.nodes.filter((n): n is TextNode => n.type === 'text');
    const node = textNodes[index];
    if (!node) {
        return fallback;
    }
    return typeof node.text === 'function' ? node.text() : node.text;
}
